import gsap from 'gsap';

export default function Hero() {
	const hero = document.querySelector('.hero');
	if (!hero) return;

	const heroContent = hero.querySelector('.hero__content');
	const image = hero.querySelector('.hero__image');
	if (!image || !heroContent) return;

	// Step 1: Set the height based on the image
	const height = image.offsetHeight;
	heroContent.style.height = `${height}px`;

	// Step 2: Wait for reflow
	requestAnimationFrame(() => {
		// Step 3: Mark the hero as image-loaded
		hero.classList.add('hero--image-loaded');

		// Step 4: Run GSAP animations
		const tl = gsap.timeline().delay(1.5);

		const text = hero.querySelector('.hero__text .flexible-content');
		if (text) {
			tl.to(text.querySelectorAll('h1,h2,p,.c-button'), {
				y: 0,
				opacity: 1,
				duration: 1,
			});
		}

		const search = hero.querySelector('.hero__search');
		if (search) {
			tl.to(
				search,
				{
					opacity: 1,
					y: 0,
					duration: 1,
				},
				'-=0.5'
			); // overlap by 0.5s
		}

		tl.call(() => {
			hero.classList.add('hero--loaded');
		});
	});
}
